(function () {
  var gate = window.__MHS_OVERLAY__ || {};
  var html = document.documentElement;
  var SESSION_KLAVIYO_KEY = "mhs_klaviyo_shown_session";

  function getBanner() {
    return document.getElementById("shopify-pc__banner");
  }

  function isBannerVisible(banner) {
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      parseFloat(style.opacity) > 0 &&
      banner.offsetHeight > 0 &&
      banner.offsetWidth > 0
    );
  }

  function isKlaviyoShownThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KLAVIYO_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markKlaviyoShown() {
    try {
      sessionStorage.setItem(SESSION_KLAVIYO_KEY, "1");
    } catch (e) {}
    if (gate.markKlaviyoOpen) gate.markKlaviyoOpen();
  }

  function hideVinovaModal() {
    var popup = document.getElementById("popup-subscribe");
    if (!popup) return;

    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.modal) {
      window.jQuery(popup).modal("hide");
    }

    popup.classList.remove("show", "in");
    popup.setAttribute("aria-hidden", "true");
    popup.style.display = "none";

    document.querySelectorAll(".modal-backdrop").forEach(function (node) {
      node.remove();
    });
    if (gate.restorePageInteraction) gate.restorePageInteraction();
  }

  function isKlaviyoVisible() {
    var nodes = document.querySelectorAll(
      '[class*="klaviyo-form"], [class*="klaviyo-popup"], [class*="kl-private"]:not([class*="kl-teaser"]), iframe[src*="klaviyo"]'
    );
    return Array.prototype.some.call(nodes, function (el) {
      if (!(el instanceof HTMLElement)) return false;
      var style = window.getComputedStyle(el);
      return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        parseFloat(style.opacity) > 0 &&
        el.offsetHeight > 80 &&
        el.offsetWidth > 80
      );
    });
  }

  function isKlaviyoTeaserVisible() {
    var nodes = document.querySelectorAll('[class*="kl-teaser"], [class*="kl-private"][class*="kl-teaser"]');
    return Array.prototype.some.call(nodes, function (el) {
      if (!(el instanceof HTMLElement)) return false;
      var style = window.getComputedStyle(el);
      return style.display !== "none" && style.visibility !== "hidden" && el.offsetHeight > 20;
    });
  }

  function bindBannerButtons() {
    var banner = getBanner();
    if (!banner || banner.__mhsBound) return;
    banner.__mhsBound = true;

    banner.addEventListener(
      "click",
      function (event) {
        if (!event.target.closest("button")) return;
        window.setTimeout(function () {
          if (!isBannerVisible(getBanner()) && gate.resolveConsent) {
            gate.resolveConsent();
          }
          scheduleApplyState();
        }, 300);
      },
      true
    );
  }

  var applyStateTimer = null;

  function scheduleApplyState() {
    if (applyStateTimer) clearTimeout(applyStateTimer);
    applyStateTimer = setTimeout(function () {
      applyStateTimer = null;
      applyState();
    }, 150);
  }

  function observeBanner() {
    var banner = getBanner();
    if (!banner || banner.__mhsObserved) return;
    banner.__mhsObserved = true;

    new MutationObserver(scheduleApplyState).observe(banner, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class", "hidden", "aria-hidden"],
    });
  }

  function watchForBanner() {
    var attempts = 0;
    var intervalId = setInterval(function () {
      attempts += 1;
      if (getBanner()) {
        clearInterval(intervalId);
        observeBanner();
      } else if (attempts >= 40) {
        clearInterval(intervalId);
      }
    }, 250);
  }

  function watchBodyScrollLock() {
    if (!document.body || document.body.__mhsScrollObserved) return;
    document.body.__mhsScrollObserved = true;
    new MutationObserver(function () {
      if (
        document.body.classList.contains("klaviyo-prevent-body-scrolling") &&
        !isKlaviyoVisible()
      ) {
        if (gate.restorePageInteraction) gate.restorePageInteraction();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ["class", "style"] });
  }

  function applyState() {
    bindBannerButtons();
    var bannerOpen = isBannerVisible(getBanner());
    var klaviyoModalOpen = isKlaviyoVisible() && gate.klaviyoAllowed;
    var klaviyoTeaserOpen = isKlaviyoTeaserVisible() && gate.klaviyoTeaserAllowed;

    if (bannerOpen) {
      if (gate.hideTidioNow) gate.hideTidioNow();
      hideVinovaModal();
    }

    if (klaviyoModalOpen || klaviyoTeaserOpen) {
      markKlaviyoShown();
    } else if (gate.markKlaviyoClosed) {
      gate.markKlaviyoClosed();
    }

    if (isKlaviyoShownThisSession() && klaviyoTeaserOpen) {
      if (gate.markKlaviyoOpen) gate.markKlaviyoOpen();
    }

    if (bannerOpen || !gate.klaviyoAllowed || isKlaviyoShownThisSession()) {
      hideVinovaModal();
    }

    if (!klaviyoModalOpen && !klaviyoTeaserOpen && gate.restorePageInteraction) {
      gate.restorePageInteraction();
    }
  }

  function initPrivacy() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function () {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy) return;

        if (typeof privacy.shouldShowBanner === "function" && !privacy.shouldShowBanner()) {
          if (gate.resolveConsent) gate.resolveConsent();
          return;
        }

        if (typeof privacy.currentVisitorConsent === "function") {
          var consent = privacy.currentVisitorConsent();
          if (
            consent &&
            (consent.analytics || consent.marketing || consent.preferences || consent.sale_of_data)
          ) {
            if (gate.resolveConsent) gate.resolveConsent();
          }
        }
      }
    );
  }

  function init() {
    initPrivacy();
    watchBodyScrollLock();
    applyState();
    watchForBanner();

    document.addEventListener("click", scheduleApplyState, true);
    window.addEventListener("load", function () {
      scheduleApplyState();
    });
    window.setInterval(function () {
      if (document.body && document.body.classList.contains("klaviyo-prevent-body-scrolling") && !isKlaviyoVisible()) {
        if (gate.restorePageInteraction) gate.restorePageInteraction();
      }
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
